
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import desktopImageWebp from './images/investment-advisory-services-hero.webp';
import mobileImageWebp from './images/investment-advisory-services-hero-mobile.webp';
// low res image
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// style imports
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='investment-advisory-services-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName='Investment Advisory Services'
      headingText={<>Investment strategies as unique as <WidowBlock>your goals.</WidowBlock></>}
      descriptionText={<>When you&#39;re looking for hands&#45;on help, our investment advisory services can be a smart choice. Want a better understanding of how investments are tied to your wealth&#63;</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Start investing',
        ariaLabel: 'Learn about investment strategies with a financial professional',
        children: '',
      }}
      backgroundImageAriaLabel='a man and woman smile at a sunset while standing on a rocky beachfront'
      backgroundImageDesktop={desktopImageWebp.toString()}
      backgroundImageMobile={mobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
